import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Find.css';

function FindUsername() {
	const [email, setEmail] = useState('');
	const [result, setResult] = useState(null);
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setResult(null);
		setLoading(true);

		try {
			const response = await axios.post('http://127.0.0.1:8000/api/users/find-username/', {
				email: email
			});

			setResult(response.data);
		} catch (error) {
			if (error.response?.data?.error) {
				setError(error.response.data.error);
			} else {
				setError('아이디 찾기에 실패했습니다. 다시 시도해주세요.');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="find-container">
			<div className="find-box">
				<h2>아이디 찾기</h2>
				<p className="find-description">가입 시 등록한 이메일 주소를 입력하세요.</p>

				{error && (
					<div className="error-message">
						{error}
					</div>
				)}

				{result && (
					<div className="success-message">
						<p>✅ 회원님의 아이디는 <strong>{result.username}</strong> 입니다.</p>
						<p className="info-text">가입일: {new Date(result.date_joined).toLocaleDateString()}</p>
					</div>
				)}

				<form onSubmit={handleSubmit}>
					<div className="form-group">
						<label>이메일</label>
						<input
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="example@email.com"
							required
						/>
					</div>

					<button
						type="submit"
						className="btn-submit"
						disabled={loading}
					>
						{loading ? '확인 중...' : '아이디 찾기'}
					</button>
				</form>

				<div className="find-footer">
					<Link to="/find-password">비밀번호 찾기</Link>
					<span className="divider">|</span>
					<Link to="/login">로그인</Link>
					<span className="divider">|</span>
					<Link to="/register">회원가입</Link>
				</div>
			</div>
		</div>
	);
}

export default FindUsername;